import { render, staticRenderFns } from "./LinkEx.vue?vue&type=template&id=629087fc&"
import script from "./LinkEx.vue?vue&type=script&lang=ts&"
export * from "./LinkEx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports